module.exports = __webpack_public_path__ + "static/media/change.ab8d5f98.png";